const HAS_LETTER_OR_NUMBER = /[\p{L}\p{N}]/u;

const validateId = (value, label) => {
    const text = typeof value === "string" ? value.trim() : "";
    if (!text) return `${label} is required.`;
    if (text.includes("#")) return `${label} cannot contain "#".`;
    return "";
};

const validatePlanName = (value) => {
    const text = typeof value === "string" ? value.trim() : "";
    if (!text) return "Plan Name is required.";
    if (!HAS_LETTER_OR_NUMBER.test(text)) return "Plan Name must contain a letter or number.";
    return "";
};

const validatePlanForm = (values, { requireIdentity = false } = {}) => {
    const errors = {};
    if (requireIdentity) {
        const clientError = validateId(values.clientId, "Client");
        if (clientError) errors.clientId = clientError;
        const planIdError = validateId(values.planId, "Plan ID");
        if (planIdError) errors.planId = planIdError;
    }
    const nameError = validatePlanName(values.displayName);
    if (nameError) errors.displayName = nameError;
    return errors;
};

const buildCreateBody = ({ clientId, planId, displayName, planName, status }) => {
    const body = {
        clientId: clientId.trim(),
        planId: planId.trim(),
        displayName,
        status,
    };
    const source = typeof planName === "string" ? planName.trim() : "";
    if (source) body.planName = source;
    return body;
};

const buildUpdateBody = ({ displayName, planName, status }) => ({
    displayName,
    planName: typeof planName === "string" ? planName.trim() : "",
    status,
});

export { validatePlanForm, buildCreateBody, buildUpdateBody };
